<template>
  <div class="HomeCardCarousel py-3"
    v-if="content.length > 0 || (cardType === 'corporateEvent' && (!hideIfEmpty || selectedEventLocation !== 'all'))"
    @mouseover="showArrows = true" @mouseleave="showArrows = false"
    :class="[showArrows ? null : 'hide-arrows', bottomNav && !hasOverflow ? 'not-scrollable' : null]">
    <div v-if="loaded || cardType === 'corporateEvent'">
      <div class="mb-3 container d-flex flex-row justify-content-between align-items-center">
        <div class="d-flex flex-row align-items-center justify-content-between mb-2 w-100">
          <h3 class="home-title mb-0 mr-5">{{ title }}</h3>
          <div class="btn btn-cta btn-view-more rounded-0" @click="seeMore">
            View All <i class="fa-solid fa-chevron-right"></i>
          </div>
        </div>
      </div>
      <div class="mb-3 container d-flex flex-row justify-content-between align-items-center" v-if="promoText">
        <div class="brand-text promoText">{{ promoText }}</div>
      </div>
      <div class="container px-0" v-if="cardType === 'corporateEvent'">
        <div v-if="locationsLoading">
          <b-spinner></b-spinner>
        </div>
        <b-form-select v-else v-model="selectedEventLocation" class="select-location mt-4 mb-5 confirm-input">
          <option v-for="location in eventLocations" :value="location.value">{{ location.label }}</option>
        </b-form-select>
      </div>
      <div class="position-relative">
        <div class="pb-5 container" :class="{ 'position-relative': bottomNav }" v-if="loaded">
          <slick v-if="content.length > 0" id='slick-id' ref="slick" :options="slickOptions" @afterChange="handleSwipe"
            @beforeChange="handleBeforeChange" class="justify-content-start h-100"
            :class="cardType === 'event' ? 'event-slick' : ''">
            <!--                    <div :key="i" v-for="(item, i) in content" @click="cardLink(item)">-->
            <div class="h-100 py-3" :key="i" v-for="(item, i) in content">
              <HomeRecipeCard :item="item" :type="type" v-if="type.includes('recipe')" :swiping="swiping">
              </HomeRecipeCard>
              <ArticleCard :item="item" :type="type" v-else-if="cardType === 'article'" :swiping="swiping">
              </ArticleCard>
              <EventCard :item="item" :type="type" v-else-if="cardType === 'corporateEvent'" :swiping="swiping">
              </EventCard>
              <HomeClinicCard :item="item" v-else-if="type === 'clinic'" type="clinic" :swiping="swiping"
                :settings="clinicSettings"></HomeClinicCard>
              <VimeoCard :mute="mute" :video="item" :type="type" v-else-if="isVimeoVideo(item, type)" :swiping="swiping"
                :perma-tag="permaTag" :reminders="reminders" :unique_id="genRandonString(10)"></VimeoCard>
              <CourseCard :item="item" :type="type" v-else-if="item.source === 'ResCourses'" :swiping="swiping" />
              <VideoCard :video="item" :type="type" v-else-if="item.media === 'video'" :swiping="swiping" />
              <PodcastCard :podcast="item" :type="type" v-else-if="item.media === 'audio'" :swiping="swiping"
                :unique_id="genRandonString(10)" />
              <PodcastCard :podcast="item" :type="type" v-else-if="item.media === 'text'" :swiping="swiping"
                :unique_id="genRandonString(10)" />
              <PodcastCard :podcast="item" :type="type" v-else-if="item.media === 'podcasts'" :swiping="swiping"
                :unique_id="genRandonString(10)" />

            </div>
            <div class="d-flex justify-content-start align-items-center" :class="{ hideLoader: !loading_new_content }"
              v-if="page <= totalPages">
              <Loader v-if="loading_new_content && type !== 'recipes'" />
            </div>
          </slick>
          <div v-else-if="cardType === 'corporateEvent'">
            <h3>No events found at the selected location, please select a different location or choose "Show all" to see
              all available events</h3>
          </div>
          <button
            v-if="bottomNav && hasOverflow"
            class="carousel-pause-btn"
            @click="toggleAutoplay"
            :title="isAutoplayActive ? 'Pause autoplay' : 'Play autoplay'"
          >
            <i :class="isAutoplayActive ? 'fas fa-pause' : 'fas fa-play'"></i>
          </button>
        </div>
        <div v-else class="py-5 container d-flex flex-row justify-content-center">
          <b-spinner class="brand-primary"></b-spinner>
        </div>
        <div class="d-flex flex-row flex-nowrap video-blur-container" v-if="!isAccessibilitySite()">
          <div class="left-blur"></div>
          <div class="container w-100"></div>
          <div class="right-blur"></div>
        </div>
      </div>
    </div>
    <div v-else class="mb-3 container d-flex flex-row justify-content-between align-items-center">
      <HomeLoading />
    </div>
  </div>
</template>

<script>
import axios from "axios"
import slick from "vue-slick"
import VideoCard from "@/components/Home/New/VideoCard.vue"
import EventCard from "@/components/Home/New/EventCard.vue"
import BookingCard from "@/components/Home/New/BookingCard.vue"
import PodcastCard from "@/components/Home/New/PodcastCard.vue"
import HomeBannerEventCard from "@/components/Home/New/HomeBannerEventCard.vue";
import EventBus from "@/helpers/eventbus";
import HomeRecipeCard from "@/components/Home/New/HomeRecipeCard.vue";
import Loader from "@/components/Loader.vue";
import VimeoCard from "@/components/Home/New/VimeoCard.vue";
import CourseCard from "@/components/Home/New/CourseCard.vue";
import HomeLoading from "@/components/Home/New/HomeLoading.vue";
import HomeClinicCard from "@/components/Home/New/HomeClinicCard.vue";
import config from "@/config/constants";
import ArticleCard from "@/components/Home/New/ArticleCard.vue"
import carouselArrowsMixin from "@/mixins/carouselArrowsMixin";
import { debounce } from "@/helpers/debounce";

export default {
  name: "HomeCardCarousel",
  props: {
    title: String,
    type: String,
    cardType: String,
    permaTag: String,
    additionalTag: String,
    upcoming: {
      type: Boolean,
      default: false
    },
    promoText: {
      type: String,
      default: null
    },
    mute: {
      type: Boolean,
      default: false
    },
    startingTag: {
      type: String,
      default: null
    },
    hideIfEmpty: {
      type: Boolean,
      default: false
    },
    ignoreGlobalFilters: {
      type: Boolean,
      default: false
    },
    bottomNav: {
      type: Boolean,
      default: false
    }
  },
  components: {
    HomeLoading,
    HomeClinicCard,
    HomeRecipeCard,
    VideoCard,
    EventCard,
    BookingCard,
    PodcastCard,
    HomeBannerEventCard,
    slick,
    Loader,
    VimeoCard,
    CourseCard,
    ArticleCard
  },
  data() {
    return {
      windowWidth: typeof window !== "undefined" ? window.innerWidth : 1024,
      eventLocations: [{ label: 'Show all', value: 'all' }],
      selectedEventLocation: 'all',
      locationsLoading: true,
      reminders: [],
      swiping: false,
      loaded: false,
      loading_new_content: false,
      content: [],
      events: [],
      page: 1,
      totalRecords: 0,
      totalPages: 0,
      optionalTag: [],
      showArrows: false,
      clinicSettings: null,
      searchTerm: '',
      isAutoplayActive: true,
      rewindTimer: null,
      inView: false,
      autoplayObserver: null,
      isScrollable: false,
      slickOptions: {
        initialSlide: 0,
        arrows: true,
        slidesToScroll: 1,
        slidesToShow: 3,
        rows: 2,
        nextArrow:
          '<div class="slick-arrow-next std-arrow">' +
          '<a class="slick-arrow-container std-arrow-container"><i class="fas fa-chevron-right text-white fa-4xs"></i></a>' +
          '</div>',
        prevArrow:
          '<div class="slick-arrow-prev std-arrow">' +
          '<a class="slick-arrow-container std-arrow-container"><i class="fas fa-chevron-left text-white fa-4xs"></i></a>' +
          '</div>',
        adaptiveHeight: true,
        // NOTE: kept infinite:false here, unlike AutomaticCarousel which uses
        // infinite:true to avoid slick's autoplay "bounce" off the last slide.
        // We can't do the same on these carousels because of `rows: 2` (slick's
        // infinite/clone mode is glitchy with grid rows) and because the Events
        // carousel paginates (load-more on scroll), which infinite looping would
        // break. The (rarely-reached) end-of-list loop is handled by
        // handleAutoplayRewind instead.
        infinite: false,
        responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1,
            },
          },
          {
            breakpoint: 951,
            settings: {
              slidesToShow: 2,
            },
          },
          {
            breakpoint: 1066,
            settings: {
              slidesToShow: 3
            }
          },
          {
            breakpoint: 1315,
            settings: {
              slidesToShow: 4
            }
          }
        ],
      },
      eventSlickOptions: {
        initialSlide: 0,
        arrows: true,
        slidesToScroll: 1,
        slidesToShow: 1,
        nextArrow:
          '<div class="slick-arrow-next">' +
          '<a class="bg-brand-highlight-1 slick-arrow-container"><i class="fas fa-chevron-right text-white fa-4xs"></i></a>' +
          '</div>',
        prevArrow:
          '<div class="slick-arrow-prev">' +
          '<a class="bg-brand-highlight-1 slick-arrow-container"><i class="fas fa-chevron-left text-white fa-4xs"></i></a>' +
          '</div>',
        adaptiveHeight: true,
        infinite: false,
        responsive: [
          {
            breakpoint: 1300,
            settings: {
              slidesToShow: 1,
            },
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1,
            },
          }
        ],
      },
    };
  },
  computed: {
    hasOverflow() {
      if (!this.bottomNav) return true;
      const count = this.content.length;
      if (this.windowWidth < 768) return count > 1;
      if (this.windowWidth < 951) return count > 2;
      if (this.windowWidth < 1066) return count > 3;
      if (this.windowWidth < 1315) return count > 4;
      return count > 3;
    }
  },
  methods: {
    // Bottom-nav (AutomaticCarousel-style) helpers, reused from the shared mixin.
    getArrowConfig: carouselArrowsMixin.methods.getArrowConfig,
    injectCarouselStyles: carouselArrowsMixin.methods.injectCarouselStyles,
    centerActiveDot: carouselArrowsMixin.methods.centerActiveDot,
    refreshDots() {
      if (this.bottomNav) {
        this.$nextTick(() => {
          this.centerActiveDot();
          this.setupAutoplayObserver();
          this.updateScrollable();
        });
      }
    },
    // The carousel only actually scrolls when slick renders more than one page
    // of dots; otherwise the autoplay/pause control is meaningless.
    updateScrollable() {
      if (!this.$el || typeof this.$el.querySelectorAll !== "function") {
        this.isScrollable = false;
        return;
      }
      this.isScrollable = this.$el.querySelectorAll(".slick-dots li").length > 1;
    },
    // Autoplay only while the carousel is scrolled into view (set up once the
    // real element exists, i.e. after content has loaded).
    setupAutoplayObserver() {
      if (!this.bottomNav || this.autoplayObserver || typeof IntersectionObserver === 'undefined') return;
      if (!(this.$el instanceof Element)) return;
      this.autoplayObserver = new IntersectionObserver(entries => {
        this.inView = entries[0].isIntersecting;
        this.updateAutoplay();
      }, { threshold: 0.25 });
      this.autoplayObserver.observe(this.$el);
      // Stop autoplay as soon as the user navigates via a dot or arrow.
      this.$el.addEventListener("click", this.pauseOnManualNav);
      // slick kills its autoplay on a drag/swipe; revive it when the touch ends.
      this.$el.addEventListener("mouseup", this.resumeAutoplayAfterInteraction);
      this.$el.addEventListener("touchend", this.resumeAutoplayAfterInteraction);
      // Pause straight away (inView is still false) so it doesn't autoplay
      // off-screen; the observer's first callback resumes it if it's visible.
      this.updateAutoplay();
    },
    updateAutoplay() {
      if (!this.$refs.slick) return;
      if (this.inView && this.isAutoplayActive) {
        this.$refs.slick.play();
      } else {
        this.$refs.slick.pause();
      }
    },
    // slick pauses its own autoplay on any drag/swipe and doesn't resume it, so
    // re-arm autoplay once the interaction ends. updateAutoplay() is a no-op if
    // the user explicitly paused (dot/arrow/pause btn) or it's scrolled out of view.
    resumeAutoplayAfterInteraction() {
      clearTimeout(this._resumeTimer);
      this._resumeTimer = setTimeout(() => this.updateAutoplay(), 350);
    },
    toggleAutoplay() {
      this.isAutoplayActive = !this.isAutoplayActive;
      this.updateAutoplay();
    },
    // Clicking a dot or arrow is manual navigation — stop the autoplay.
    pauseOnManualNav(e) {
      if (!this.isAutoplayActive || !e.target || !e.target.closest) return;
      if (
        e.target.closest(".slick-dots") ||
        e.target.closest(".bottom-arrow") ||
        e.target.closest(".slick-arrow")
      ) {
        this.isAutoplayActive = false;
        this.updateAutoplay();
      }
    },
    handleAutoplayRewind(slick, currentSlide) {
      // Loop back to the start once the last slide is reached (matches AutomaticCarousel),
      // but only after every page has loaded so it doesn't fight infinite-scroll pagination.
      if (!slick || !this.isAutoplayActive || !this.inView || this.page <= this.totalPages) return;
      const slidesToShow = slick.slickGetOption("slidesToShow");
      if (slidesToShow <= 1) return;
      const lastIndex = slick.slideCount - slidesToShow;
      clearTimeout(this.rewindTimer);
      if (currentSlide >= lastIndex) {
        const interval = slick.slickGetOption("autoplaySpeed") || 5000;
        this.rewindTimer = setTimeout(() => {
          if (!this.$refs.slick || !this.isAutoplayActive || !this.inView) return;
          // Jump back instantly (dontAnimate) so it doesn't visibly scroll backwards.
          this.$refs.slick.goTo(0, true);
          this.$nextTick(() => this.updateAutoplay());
        }, interval);
      }
    },
    async getLocations() {
      let self = this;
      const payload = {
        user_id: this.$store.getters.user_id
      };
      let res = await axios.post(
        config.api_env + "/application/api-hc/get-locations",
        payload,
        config.options
      );
      if (res.data.success) {

        res.data.locations.forEach((location) => {
          self.eventLocations.unshift({ label: location.location_label, value: location.location_id })
        })
        this.locationsLoading = false;
      } else if (res.data.err && res.data.err.includes("3994")) {
        this.$store.dispatch("logout");
        this.$router.push("/login");
      }
    },
    isVimeoVideo(video, type) {
      if (type === 'studio' || type === 'gym') return true;
      return (video.url && video.url.includes('vimeo')) || (video.embed_video && video.embed_video.includes('vimeo'));
    },
    seeMore() {
      let type = this.type
      let subType = this.additionalTag;
      if (type === 'corporateEvent') {
        this.$router.push("/content/events");
      } else {
        if (this.additionalTag === 'Videos') {
          this.$router.push('/content/videos');
        } else {
          this.$router.push('/content/articles')
        }
      }
      this.scrollToRef(null, true);
    },
    handleBeforeChange() {
      //prevents reroute whilst tiles are in motion
      this.swiping = true;
      setTimeout(() => { this.swiping = false }, 1000)
    },
    async handleSwipe(event, slick, currentSlide) {
      const threshold = 9;
      if (
        this.content.length - currentSlide * 2 <= threshold &&
        this.page <= this.totalPages
      ) {
        this.loading_new_content = true;
        await this.getContent();
      }
      this.refreshDots();
      if (this.bottomNav) this.handleAutoplayRewind(slick, currentSlide);
    },
    async getContent(reInit = false, restart = false, startingTag = null) {
      this.loading_new_content = true;
      let contentPath = '';
      let contentType;
      switch (this.type) {
        case 'corporateEvent':
          contentPath = "/application/api/u/sapphire/home/content";
          contentType = 'events'
          break;
        case 'standaloneArticles':
          contentPath = "/application/api/u/sapphire/home/content";
          contentType = 'articles'
          break;
        case 'featured-event':
          contentPath = "/application/api/u/studio/events/trending";
          contentType = 'events'
          break;
        case 'recipes':
          contentPath = "/application/api/u/content/nutrition";
          contentType = 'articles'

          break;
        case 'clinic':
          contentPath = "/application/api/u/home/get-dc-banner";
          contentType = 'courses'
          break;
        default:
          contentPath = "/application/api/u/sapphire/home/content";
          contentType = 'events'

      }
      if (restart) this.page = 1;
      let tags = [];
      if (this.optionalTag.length > 0) {
        tags.unshift(this.optionalTag[0])
      }
      if (this.additionalTag) {
        tags.unshift(this.additionalTag);
      }
      if(startingTag) {
        tags.unshift(startingTag);
      }
      const payload = {
        user_id: this.$store.getters.user_id,
        tags: tags,
        search_term: this.searchTerm,
        type: contentType,
        page: this.page,
        pageSize: 12
      };
      if (this.permaTag) {
        payload.tags.push(this.permaTag)
      }
      if (this.upcoming) {
        payload.upcoming = true;
      }
      if (this.type === "exercise") {
        payload.sort = "rank";
        payload.order = "asc";
      }
      if (this.cardType === 'corporateEvent') {
        payload.filter = this.selectedEventLocation;
      }
      let res = await this.axios.post(
        process.env.VUE_APP_API_PATH +
        contentPath,
        payload, config.options
      );
      this.loaded = true;

      if (res.data.success && !res.data.data) {
        res.data.data = []
      }
      if (res.data.success && !res.data.meta) {
        res.data.meta = {
          pagination: {
            current_page: 1,
            per_page: 6,
            total_pages: 0,
            total: 0,
            has_next_page: false,
            has_prev_page: false
          }
        }
      }
      if (res.data.success) {
        if (this.type === 'clinic') {
          this.content = res.data.categories;
          this.totalRecords = res.data.categories.length;
          this.totalPages = 0;
          this.clinicSettings = res.data.dc_setting;
        } else if (this.type === 'standaloneArticles' && res.data.content) {
          this.content = res.data.content;
          this.totalRecords = res.data.content.length;
          this.totalPages = 0;
        } else if (this.page === 1) {
          this.content = res.data.data;
          this.totalRecords = res.data.meta.pagination.total;
          this.totalPages = res.data.meta.pagination.total_pages;
          this.page++;
          if (reInit) this.reinitSlider(true);
        } else {
          this.loading_new_content = false;
          this.content = this.content.concat(res.data.data);
          this.page++;
          this.reinitSlider();
        }
      } else if (res.data.err && res.data.err.includes("3994")) {
        this.$store.dispatch("logout");
        this.$router.push("/login");
      } else {
        console.log('no data')
        this.loading_new_content = false;
        this.loaded = true;
      }
      this.refreshDots();
    },
    reinitSlider(backToStart = false) {
      let self = this;
      if (backToStart) this.slickOptions.initialSlide = 0;
      if (self.$refs.slick) {
        let currentSlide = backToStart ? 0 : self.$refs.slick.currentSlide();
        this.$refs.slick.destroy();
        this.$nextTick(() => {
          let options = this.type === 'featured-event' ? self.eventSlickOptions : self.slickOptions;
          options.initialSlide = currentSlide;
          self.$refs.slick.create(options);
          self.refreshDots();
          if (self.bottomNav) self.updateAutoplay();
        });
      }
      this.loading_new_content = false;
    },

  },
  created() {
    if (this.bottomNav) {
      // Match AutomaticCarousel: arrows + dots along the bottom, keep the 2 rows.
      this.slickOptions = {
        ...this.slickOptions,
        dots: true,
        // Autoplay runs only while in view (IntersectionObserver). Don't pause on
        // hover/focus: on mobile, scrolling the page requires touching it, which
        // would otherwise focus the carousel and stop autoplay from ever starting.
        // Pausing happens only on explicit controls (pause button + dot/arrow
        // clicks); incidental scroll-touches must not stop autoplay.
        autoplay: true,
        autoplaySpeed: 5000,
        pauseOnHover: false,
        pauseOnFocus: false,
        ...this.getArrowConfig()
      };
    }
  },
  mounted() {
    let self = this;
    if (this.bottomNav) {
      this.injectCarouselStyles();
      this._onCarouselResize = debounce(() => {
        this.windowWidth = window.innerWidth;
        this.updateScrollable();
      }, 250);
      window.addEventListener("resize", this._onCarouselResize);
    }
    if (this.cardType === 'corporateEvent') {
      this.getLocations();
    }
    if (!this.ignoreGlobalFilters) {
      EventBus.$on("setTag", function (tag) {
        if (tag) {
          self.optionalTag = [tag];
        } else {
          self.optionalTag = [];
        }
      });
      EventBus.$on("setSearch", function (search) {
        self.searchTerm = search
      });
    }
    this.getContent(true, false, this.startingTag);
    EventBus.$on('setBookingReminders', (data) => {
      this.reminders = data;
    })
    EventBus.$on('locationChange', () => {
      self.loaded = false;
      if (self.$refs.slick) {
        self.$refs.slick.goTo(0);
      }
      self.page = 1;
      self.getContent(true, true);
    })
  },
  beforeDestroy() {
    clearTimeout(this.rewindTimer);
    clearTimeout(this._resumeTimer);
    if (this.autoplayObserver) this.autoplayObserver.disconnect();
    if (this._onCarouselResize) window.removeEventListener("resize", this._onCarouselResize);
    if (this.$el && this.$el.removeEventListener) {
      this.$el.removeEventListener("click", this.pauseOnManualNav);
      this.$el.removeEventListener("mouseup", this.resumeAutoplayAfterInteraction);
      this.$el.removeEventListener("touchend", this.resumeAutoplayAfterInteraction);
    }
  },
  watch: {
    optionalTag() {
      if (this.type !== 'featured-event') {
        this.loaded = false;
        if (this.$refs.slick) {
          this.$refs.slick.goTo(0);
        }
        this.page = 1;
        this.getContent(true, true);
      }
    },
    searchTerm() {
      if (this.type !== 'featured-event') {
        this.loaded = false;
        if (this.$refs.slick) {
          this.$refs.slick.goTo(0);
        }
        this.page = 1;
        this.getContent(true, true);
      }
    },
    selectedEventLocation() {
      if (this.type !== 'featured-event') {
        this.loaded = false;
        if (this.$refs.slick) {
          this.$refs.slick.goTo(0);
        }
        this.page = 1;
        this.getContent(true, true);
      }
    },
  },
};
</script>

<style lang="less">
.HomeCardCarousel {
  // The shared dots style positions them at `bottom: 17%`, a percentage of
  // slider height. On these taller two-row sliders that overshoots the 130px
  // reserved band and lands on the cards (worse with 2-line titles). The band
  // is a constant 130px (100px on mobile), so pin the dots just below the cards
  // with a fixed offset that hugs them the way AutomaticCarousel does.
  .slick-dots {
    bottom: 112px !important;
  }

  // When the carousel can't scroll there are no arrows/dots/pause button, so
  // drop the reserved bottom band to avoid a large empty gap below the cards.
  &.not-scrollable .slick-slider {
    padding-bottom: 0 !important;
  }

  @media (max-width: 768px) {
    .slick-dots {
      bottom: 82px !important;
    }
  }

  .carousel-pause-btn {
    position: absolute;
    bottom: 60px;
    left: 0;
    width: 60px;
    height: 60px;
    border-radius: 50%;
    border: 2px solid white;
    background-color: rgba(0, 0, 143, 0.95);
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    z-index: 20;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.25);
    transition: all 0.3s ease;

    &:hover {
      background-color: rgba(0, 0, 143, 1);
      box-shadow: 0 6px 16px rgba(0, 0, 0, 0.35);
    }

    i {
      font-size: 20px;
      color: white;
    }
  }

  @media (max-width: 768px) {
    .carousel-pause-btn {
      // On mobile the container is full-width, so `left: 0` sits flush against
      // the screen edge. Inset it by the container padding so it mirrors the
      // arrows' 15px gap on the right.
      left: 15px;
      width: 44px;
      height: 44px;

      i {
        font-size: 18px;
      }
    }
  }

  .confirm-input {
    font-family: "DMSans";
    font-size: 1.8rem;
    padding: 12.5px;
    height: 50px;
    margin-left: 10px;
    border: 1px solid #d3d3d3;
    border-radius: 8px;
    width: 300px;
    max-width: 100%;
  }

  .slick-track {
    display: flex !important;
  }

  //.slick-slide {
  //  height: inherit !important;
  //}
  //
  //.slick-slide>div:first-child {
  //  height: 100% !important;
  //}



  .slick-arrow {
    position: absolute;
    top: 50%;
    transform: translateY(-30%);
    z-index: 10;
    background-color: transparent;
    border: none;
    font-size: 1rem;

    &:focus {
      outline: none;
    }
  }

  &.hide-arrows {
    .std-arrow {
      display: none !important;
    }
  }

  .home-title {
    font-size: 2rem;
  }

  .home-title-line {
    height: 1px;
    width: 200px;
    max-width: 50%;
  }

  .promoText {
    font-family: DMSans, Arial, Helvetica, sans-serif;
    font-size: 1.75rem;
  }

  .hideLoader {
    width: 0px !important;
  }

  .slick-slide:has(.hideLoader) {
    width: 0px !important;
  }

  .see-more-link {
    font-size: 1.5em;

    &:hover {
      cursor: pointer;
    }
  }

  .slick-slider {
    .slick-slide {
      transform: scale(1);
      margin: 0 8px;
    }
  }

  .slick-list {
    margin: 0 -15px;
    overflow: visible;
  }

  .slick-arrow-container {
    display: flex;
    justify-content: center;
    align-items: center;
    align-items: center;
    border-radius: 300px;
    line-height: 0;
    padding: 10px;
    height: 100%;
    display: none;
  }

  @media only screen and (max-width: 767px) {
    .home-title-line {
      display: none !important;
    }
  }

  @media only screen and (min-width: 980px) and (max-width: 992px) {
    .slick-arrow-container {
      display: flex;
    }
  }

  @media only screen and (min-width: 1130px) and (max-width: 1200px) {
    .slick-arrow-container {
      display: flex;
    }
  }

  @media only screen and (min-width: 1320px) {
    .slick-arrow-container {
      display: flex;
    }
  }

  .displayLoader {}

  .slick-arrow-next {
    right: -45px;
  }

  .slick-arrow-prev {
    left: -75px;
  }

  .std-arrow {
    top: 50% !important;
    transform: translateY(-50%) !important;

    &.slick-arrow-next {
      right: -60px;
    }

    &.slick-disabled {
      display: none !important;
    }

    &.slick-arrow-prev {
      left: -60px;
    }

    .std-arrow-container {
      background-color: rgba(0, 0, 143, 0.95) !important;
      width: 60px !important;
      height: 60px !important;
      border-radius: 50% !important;
      padding: 0 !important;

      i {
        color: white !important;
        font-size: 24px !important;
      }
    }
  }

  .slick-track {
    margin-left: 0;
  }

  .slick-slide.slick-active {
    pointer-events: auto;
    opacity: 1;
  }

  .slick-slide {
    pointer-events: none;

    button, a, [role="button"], .btn {
      pointer-events: auto;
    }
  }

  .slick-disabled {
    .bg-brand-highlight-1 {
      background-color: #eee;
      cursor: default;
    }
  }

  .btn-view-more {
    font-size: 1.6rem !important;
  }

  .video-blur-container {
    pointer-events: none;
    position: absolute;
    top: 0;
    height: 100%;
    width: 100%;

    .container {
      flex-grow: 1;

    }

    .left-blur {
      flex-grow: 1;
      background: rgb(247, 247, 247);
      background: linear-gradient(
        270deg,
        rgba(250, 250, 250, 0) 5%,
        rgba(250, 250, 250, 0.7) 15%,
        rgba(250, 250, 250, 1) 45%
      );
    }

    .right-blur {
      flex-grow: 1;
      background: rgb(247, 247, 247);
      background: linear-gradient(
        90deg,
        rgba(250, 250, 250, 0) 5%,
        rgba(250, 250, 250, 0.7) 15%,
        rgba(250, 250, 250, 1) 45%
      );
    }
  }
}
</style>
